import React, { useEffect } from 'react'
import Container from '../../Container/Container'
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router';

function AddDescription({ onSubmit, onBack, ticket, initialValues }) {
    const location = useLocation()

    const profile = useSelector((state) => state.profile.profile);
    const { register, handleSubmit, formState: { errors }, getValues, setValue } = useForm({
        defaultValues: initialValues
    });

    // Update SubmittedBy field when profile data is available
    useEffect(() => {
        if (!getValues("SubmittedBy")) {
            setValue("SubmittedBy", `${profile?.firstName || ""} ${profile?.lastName || ""}`);
        }
    }, [profile, setValue, getValues]);

    const handleBack = () => {
        // Save current form values before going back
        const currentValues = getValues();
        onBack(currentValues);
    };

    console.log(initialValues, "initialValues.commented")
    return (
        <Container>
            <div class="nk-content ">
                <div class="container-fluid">
                    <div class="nk-content-inner">
                        <div class="nk-content-body">
                            <div class="nk-block-head nk-block-head-sm">
                                <div class="nk-block-between">
                                    <div class="nk-block-head-content">
                                        <h3 class="nk-block-title page-title">{location.pathname == "/add-wedding-order" ? "Add" : "Update"} Weddings Events {(ticket && location.pathname != "/add-wedding-order") && `#${ticket}`}</h3></div>
                                </div>
                            </div>


                            <div class="card card-full">
                                <div class="card-inner">
                                    <div class="stepperLeft">
                                        <div className="row">
                                            <div className="col-md-4 brIght">
                                                <section className="section1">
                                                    <header>
                                                        <div className="bead complete"><span><i class="fa-solid fa-check"></i></span></div> {location.pathname == "/add-wedding-order" ? "Add" : "Update"}  Groom Detail
                                                    </header>
                                                </section>
                                                <section className="section2">
                                                    <header>
                                                        <div className="bead complete"><span><i class="fa-solid fa-check"></i></span></div>{location.pathname == "/add-wedding-order" ? "Add" : "Update"}  Bride Detail
                                                    </header>
                                                </section>
                                                <section className="section2">
                                                    <header>
                                                        <div className="bead complete"><span><i class="fa-solid fa-check"></i></span></div>{location.pathname == "/add-wedding-order" ? "Add" : "Update"} Style Detail
                                                    </header>
                                                </section>
                                                <section>
                                                    <header>
                                                        <div className="bead current"><span>4</span></div> {location.pathname == "/add-wedding-order" ? "Add" : "Update"} Description
                                                    </header>
                                                </section>
                                            </div>






                                            <div className="col-md-8">
                                                <h4>{location.pathname == "/add-wedding-order" ? "Add" : "Update"} Description </h4>
                                                <div className="inputCardBox mt-4">
                                                    <form onSubmit={handleSubmit(onSubmit)}>
                                                        <div className="row">
                                                            <div className="col-md-12 mb-3">
                                                                <label>Notes  <span className="text-red-500"></span></label>
                                                                <textarea className="" placeholder='For Your Reference Only'  {...register("Notes")}></textarea>
                                                                {errors.Notes && <p className='red'>{errors.Notes.message}</p>}

                                                            </div>
                                                            <div className="col-md-6 mb-3">
                                                                <label>Submitted By  <span className="text-red-500">*</span></label>
                                                                <input class="" type="text" placeholder="Enter name"  {...register("SubmittedBy", { required: "Submitted by is required" })} />
                                                                {errors.SubmittedBy && <p className='red'>{errors.SubmittedBy.message}</p>}

                                                            </div>
                                                            {/* <div className="col-md-6 mb-3">
                                                                        <label>Customer Next Slip  <span className="text-red-500">*</span></label>
                                                                        <input class="" type="text" placeholder="Enter name"   {...register("NextSlip", { required: "Next slip is required" })} />
                                                                        {errors.NextSlip && <p className='red'>{errors.NextSlip.message}</p>}
    
                                                                    </div> */}

                                                            <div class="col-md-12 mt-3">
                                                                <a className="backBtnWedding" style={{ cursor: "pointer" }} onClick={handleBack}>Back</a>
                                                                <button type="submit" class="addBtnCustomer">Submit</button>
                                                            </div>

                                                        </div>
                                                    </form>

                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

        </Container>
    )
}

export default AddDescription